import React from "react";
import { metricValue } from "@/lib/evidencePresentation";

const priority = ["flood", "planning", "rent"];

export default function ReportSummaryStrip({ metrics = [] }) {
  const byId = new Map(metrics.map((metric) => [metric.id, metric]));
  const missing = metrics.filter((metric) => metric.status === "unavailable").length;
  return <section className="report-summary-strip" aria-label="Report at a glance">
    <div className="summary-strip-title"><span className="eyebrow">At a glance</span><strong>Key flags first</strong></div>
    {priority.map((id) => {
      const metric = byId.get(id);
      return <a key={id} href={metric ? `#metric-${id}` : "#evidence"} className={`summary-flag status-${metric?.status || "unavailable"}`}>
        <span>{metric?.label || id}</span>
        <strong>{metric && metric.status !== "unavailable" ? metricValue(metric) : "Not assessed"}</strong>
      </a>;
    })}
    <a href={missing ? "#evidence-gaps" : "#evidence"} className="summary-flag"><span>Evidence gaps</span><strong>{missing ? `${missing} to check` : "No missing items"}</strong></a>
  </section>;
}
